/**
 * Row and Section for rendering a diagnostics bundle as labelled fields. Shared
 * by the Super Admin panel and the report dialog's attached-context preview, so
 * a reporter and a Super Admin read the same context in the same shape.
 */

export function Row({ label, value }: { label: string; value: string | null }) {
  if (value === null || value === "") return null;
  return (
    <div className="flex flex-col gap-0.5 py-1.5">
      <dt className="text-[11px] font-medium uppercase tracking-wide text-slate-400">{label}</dt>
      <dd className="break-words text-sm text-slate-700">{value}</dd>
    </div>
  );
}

export function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  // A section whose rows all rendered null would be a bare heading.
  const hasContent = Array.isArray(children)
    ? children.some((child) => child !== null && child !== false)
    : Boolean(children);
  if (!hasContent) return null;
  return (
    <div>
      <h3 className="text-xs font-semibold text-slate-500">{title}</h3>
      <dl className="mt-1 divide-y divide-slate-100">{children}</dl>
    </div>
  );
}
